import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@/components/ui'
import type { LinePage } from './accountLines'

interface TablePagerProps {
  page: LinePage<unknown>
  onPageChange: (pageIndex: number) => void
}

export const TablePager = ({ page, onPageChange }: TablePagerProps) => (
  <div className="mt-4 flex items-center justify-between pb-2 text-[13px] text-blue-6">
    <span className="tabular-nums">
      {page.firstLine}-{page.lastLine} of {page.total.toLocaleString()}
    </span>
    <div className="flex items-center gap-2">
      <Button
        theme="outline"
        size="sm"
        className="h-8"
        disabled={page.pageIndex === 0}
        onClick={() => onPageChange(page.pageIndex - 1)}
      >
        <ChevronLeft />
        Previous
      </Button>
      <Button
        theme="outline"
        size="sm"
        className="h-8"
        disabled={page.pageIndex >= page.pageCount - 1}
        onClick={() => onPageChange(page.pageIndex + 1)}
      >
        Next
        <ChevronRight />
      </Button>
    </div>
  </div>
)
